<template>
    <b-modal size="xl" button-size="sm" hide-footer v-model="showModal" :title="prefix + title"
        @hidden="closeModalCadastroDevolucao" @close="closeModalCadastroDevolucao">
        <ModalConsultaProduto v-if="showModalProduto" @onselect="addProduto" :title="' > Produtos do Almoxarifado'"
            :prefix="'Cadastro'" :departamento="form.departamento" @close="closeModalProduto"
            @hidden="closeModalProduto" :tipoOperacao="tipoOperacao">
        </ModalConsultaProduto>

        <b-form @submit.prevent="submit">
            <b-card-body>
                <b-card bg-variant="light">
                    <b-col lg="12" sm="12" class="text-left">
                        <LgFinderPageUnidadeAdministrativa id="finderUnidadeAdministrativa"
                            :prefix="prefix + title + ' > '" invalidFeedback="Informe uma unidade administrativa"
                            v-model="form.departamento" disabled :podeApagarDepartamento="false"
                            @produtoSelect="addProduto" :podeMudarDepartamento="false" />
                    </b-col>

                    <b-col lg="12" sm="12" class="text-left">
                        <b-form-group label-for="textarea-formatter" class="col-12">
                            <label for="textarea-auto-height">Justificativa da Devolução</label>
                            <b-form-textarea id="textarea-formatter" v-model="form.justificativa" :required="true">
                            </b-form-textarea>
                        </b-form-group>
                    </b-col>

                    <b-form-row>
                        <b-col cols="12" class="text-right mb-2">
                            <b-button id="adicionar" size="sm" variant="success" style="height: 40px"
                                @click="addProdutoIntent"><b-tooltip target="adicionar"
                                    title="Adicionar item ..."></b-tooltip>
                                <div>Adicionar Produto</div>
                            </b-button>
                        </b-col>
                        <b-table id="t-devolucao-item" :busy="this.busy" responsive small :items="form.itens"
                            :fields="fieldsTabelaItens" show-empty>
                            <template #table-busy>
                                <div class="text-center text-primary my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                            </template>
                            <template #empty>
                                <h6 style="text-align: center">Nenhum produto vinculado</h6>
                            </template>
                            <template #head()="data">
                                <h6>{{ data.label.toUpperCase() }}</h6>
                            </template>

                            <template #cell(quantidadeDevolvida)="data">
                                <lg-number v-model="form.itens[data.index].quantidadeDevolvida" required
                                    :precision="{ min: 2, max: 2 }" />
                            </template>

                            <template v-slot:cell(remover)="{ item }">
                                <b-button id="remover" size="sm" variant="danger" @click="removerItem(item)">
                                    <b-icon icon="trash" />
                                    <b-tooltip target="remover" title="Remover item do pedido..."></b-tooltip>
                                </b-button>
                            </template>
                        </b-table>
                    </b-form-row>

                    <div class="d-flex justify-content-center">
                        <div class="text-right">
                            <b-button id="salvar" type="submit" variant="success" size="sm" pill style="height: 20px">
                                <b-tooltip target="salvar" title="Salvar"></b-tooltip>
                                <div class="btn-size-alinhamento">
                                    <b-icon icon="check-circle" />
                                </div>
                            </b-button>

                            <b-button id="cancelar" class="ml-2" @click="close" variant="danger" pill
                                style="height: 20px" size="sm">
                                <b-tooltip target="cancelar" title="Cancelar"></b-tooltip>
                                <div class="btn-size-alinhamento">
                                    <b-icon icon="x-circle" />
                                </div>
                            </b-button>
                        </div>
                    </div>
                </b-card>
            </b-card-body>
        </b-form>
    </b-modal>
</template>

<script>
import { required } from "vuelidate/lib/validators"

import ConfirmMixin from "@/core/mixins/confirm"
import Formatters from "@/core/mixins/formatters"
import Resource from "@/core/mixins/resource"
import ResourceService from "@/core/api/ResourceService"
import LgNumber from "@/core/components/Inputs/LgNumber.vue"
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue"
import ModalConsultaProduto from "@/core/components/Modals/ModalConsultaProduto.vue"
import StatusDevolucaoEnum from "@/core/utils/StatusDevolucaoEnum"
import TipoOperacaoAlmoxarifadoProdutoEnum from "@/core/utils/TipoOperacaoAlmoxarifadoProdutoEnum"

export default {
    components: {
        LgFinderPageUnidadeAdministrativa,
        LgNumber,
        ModalConsultaProduto,
    },

    mixins: [Formatters, ConfirmMixin, Resource.FormResourceMixin],

    props: {
        id: {
            type: Number,
            default: null,
        },
        prefix: {
            type: String,
            default: "Devolução",
        },
        title: {
            type: String,
            default: " Cadastro",
        },
    },

    created() {
        const brand = JSON.parse(localStorage.getItem("context"))
        this.form.departamento = brand.departamento
    },

    data() {
        return {
            tipoOperacao: TipoOperacaoAlmoxarifadoProdutoEnum.DEVOLUCAO,
            busy: true,
            showModal: true,
            showModalProduto: false,
            inLoading: true,
            form: {
                departamento: {},
                situacao: 1,
                itens: [{}],
                justificativa: "",
                status: { id: StatusDevolucaoEnum.EM_DIGITACAO.value },
            },
        }
    },

    validations: {
        form: {
            justificativa: { required },
            departamento: { required },
            itens: { required },
        },
    },
    async beforeMount() {
        this.$service = new ResourceService(`/api/devolucoes`)
        this.$serviceStatus = new ResourceService(`/api/status`)
        await this.carregarDevolucao()
    },

    computed: {
        fieldsTabelaItens() {
            return [
                {
                    key: "almoxarifadoProduto.produto.numero",
                    label: "Número",
                    tdClass: "py-0",
                    tdStyle: "width: 10%",
                },
                {
                    key: "almoxarifadoProduto.produto.descricaoResumida",
                    label: "Produto",
                    tdClass: "py-0 ",
                    tdStyle: "width: 40%",
                },
                {
                    key: "almoxarifadoProduto.almoxarifado.descricao",
                    label: "Almoxarifado",
                    tdClass: "py-0",
                    tdStyle: "width: 40%",
                },
                {
                    key: "quantidadeDevolvida",
                    label: "Devolver",
                    tdClass: "py-0 ",
                    tdStyle: "width: 5%",
                },

                {
                    key: "remover",
                    label: " ",
                    tdClass: "py-0 ",
                    tdStyle: "width: 5%",
                },
            ]
        },
    },

    methods: {
        async carregarDevolucao() {
            if (this.id) {
                this.busy = true

                const { data } = await this.$service.findById(this.id)
                this.busy = false
                this.form = data
                this.form.itens = data.produto
            } else {
                this.busy = false

                const brand = JSON.parse(localStorage.getItem("context"))
                this.form = {
                    departamento: brand.departamento,
                    situacao: 1,
                    itens: [],
                    justificativa: "",
                    status: { id: StatusDevolucaoEnum.EM_DIGITACAO.cod },
                }
            }

            this.inLoading = false
        },

        async addProdutoIntent() {
            this.showModalProduto = true
        },

        async addProduto(produto) {
            const produtoExistente = this.form.itens.find(
                item => item.almoxarifadoProduto.id === produto.id
            )
            if (produtoExistente) {
                this.$notify({
                    type: "warning",
                    message: "Esse Item já se encontra na lista",
                })
                return
            }

            this.form.itens.push({
                quantidadeDevolvida: 0,
                quantidadeAprovado: 0,
                quantidadeRetirada: 0,
                almoxarifadoProduto: {
                    id: produto.id,
                    produto: {
                        id: produto.produto.id,
                        numero: produto.produto.numero,
                        descricaoResumida: produto.produto.descricaoResumida,
                    },
                    almoxarifado: {
                        id: produto.almoxarifado.id,
                        descricao: produto.almoxarifado.descricao,
                    },
                },
            })
        },

        async recarregarDevolucao() {
            if (this.form$route.params.id) {
                const { data } = await this.$service.findById(this.$route.params.id)
                this.form = data
                this.inLoading = false
                return
            }
            const { data } = await this.$serviceStatus.findById(28)
            this.form.status = data
            this.inLoading = false
        },

        removerItem(item) {
            this.$confirm(
                "Deseja realmente remover o item da devolução?",
                "Remover Item"
            ).then(response => {
                if (response) {
                    const index = this.form.itens.findIndex(
                        ({ almoxarifadoProduto }) =>
                            almoxarifadoProduto.id === item.almoxarifadoProduto.id
                    )
                    if (index !== -1) {
                        this.form.itens.splice(index, 1)
                    } else {
                        this.$notify({
                            type: "warning",
                            message: "Item não encontrado na lista.",
                        })
                    }
                }
            })
        },

        async submit() {
            if (!this.formIsValid) {
                this.$v.$touch()
                this.$notify({
                    type: "danger",
                    message: "Verifique os campos do cadastro.",
                })
                return
            }

            if (this.form.itens.length == 0) {
                this.$v.$touch()
                this.$notify({
                    type: "danger",
                    message: "É preciso informar um item.",
                })
                return
            }

            const hasInvalidQuantity = this.form.itens.some(item => {
                return item.quantidadeDevolvida <= 0
            })

            if (hasInvalidQuantity) {
                this.$v.$touch()
                this.$notify({
                    type: "danger",
                    message:
                        "Preencha os campos corretamente: a quantidade devolvida deve ser maior que 0.",
                })
                return
            }

            this.busy = true

            await this.$service.saveForm(this.form).then(response => {
                if (
                    response.status === 200 ||
                    response.status === 201 ||
                    response.status === 204
                ) {
                    this.closeModalCadastroDevolucao()
                    this.$emit("submit")
                    this.$notify({
                        type: "success",
                        message: `Devolução ${this.form.id ? "cadastrada" : "atualizada"
                            } com sucesso.`,
                    })
                }
                if (response.status === 400 || response.status === 500) {
                    this.$notify({
                        type: "danger",
                        message: response.data.message,
                    })
                }
            })
        },

        close() {
            this.$emit("close")
        },

        closeModalProduto() {
            this.showModalProduto = false
        },

        closeModalCadastroDevolucao() {
            this.showModal = false
            this.$emit("close")
        },
    },
}
</script>

<style scoped lang="scss">
.in-progress {
    color: red;
    margin: 0;
}

table {
    .form-control {
        padding: 3px 9px;
        height: 30px;
        text-align: right;
    }
}
</style>
